export default "/assets/images/mila-air-mini.webp?9b5c0aa7ceabce399dd92388f4530b81";